import React from 'react';

var ReactDOM = require('react-dom');
import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var querystring = require('querystring');
import ReplyComment from './ReplyComment';
import ImagePopup from '../ImagePopup';
import LoginPopup from '../LoginPopup';
import POPUP from '../popup';

const customStyles2 = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '80px 0px',
        width: '600px',
        height: '380px',
        minHeight: '300px',
        zIndex: '999',
        textAlign: 'center'
    }
};

class CommentItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {ref: undefined, show: false, showPU: false, showLoginPopover: false, msg: ''};
    }


    componentDidMount() {
        //console.log(this.props.comment);
    }

    componentWillReceiveProps(nextProps) {
    }

    getInput(ref) {
        this.setState({ref: ref});
    }

    handleLike(event) {
        if (this.props.user == 0) {
            console.log("NOT LOGIN");
            this.setState({msg: 'like this post'});
            this.viewLoginPopover(event);
            return false;
        }

        var url = '/code/api_feeds.php?api=likeCommentFeeds&id_comment=' + this.props.comment.id_comment;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    //var newComment =Object.assign(this.props.comment,{likes:response.data.data});
                    this.props.onChange(response.data.data);
                    //this.setState(Object.assign(this.state,{feeds:response.data.data}));
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
    }

    handleDeleted(event) {
        if (this.props.user == 0) {
            this.setState({msg: 'delete this post'});
            this.viewLoginPopover(event);
            return false;
        }

        var url = '/code/api_feeds.php?api=deleteCommentFeeds&id_comment=' + this.props.comment.id_comment;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    var newComment = Object.assign(this.props.comment, {});
                    this.props.onChange(newComment, "delete");
                }
                return response;
            });
    }

    handleReply(event) {
        //if(this.state.ref!=undefined){
        this.setState({show: true}, () => {
            if (this.props.user == 0) {
                this.setState({msg: 'reply this post'});
                this.viewLoginPopover(event);
                return false;
            }
            if (this.state.ref != undefined) ReactDOM.findDOMNode(this.state.ref).focus();
        });
        //}
    }

    onClose() {
        this.setState({showPU: false});
    }

    onCloseLoginPopover() {
        this.setState({showLoginPopover: false});
    }

    viewLoginPopover(e) {
        this.setState({showLoginPopover: true});
    }

    render() {
        const commentitem = this.props.comment;
        return (
            <div>
                <div className="comment_item">
                    <div className="comment_top_box">
                        <div className="comment_w1">
                            <Link to={commentitem.avata_link}><img className="img_circle_s" src={commentitem.avata}/></Link>
                        </div>
                        <div className="comment_w2">
                            <p className="comment_content">
                                <span className="user">
                                    <Link to={commentitem.avata_link}>{commentitem.full_name}</Link>
                                </span>
                                {commentitem.content_comment}
                            </p>
                            {commentitem.id_file_comment > 0 ? (
                                <div className="comment_img">
                                    <a onClick={() => this.setState({showPU: true})}>
                                        <img src={commentitem.file.link_thumb_file}/>
                                    </a>
                                    <POPUP style={commonApi.ImagePopupStyle()} show={this.state.showPU} onClose={this.onClose.bind(this)} content={( <ImagePopup onClose={this.onClose.bind(this)} img={commentitem.file.link_file}/>)}/></div>)
                            : ""
                            }
                            {this.props.user.id_account == this.props.comment.id_account_comment ?
                                <span onClick={this.handleDeleted.bind(this)} className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                            :""}
                        </div>
                    </div>
                    <div className="comment_bot_box">
                        <div className="like_comment">
                            <a onClick={this.handleLike.bind(this)}>{commentitem.liked == 1 ? "Liked" : "Like"}&nbsp;({commentitem.likes.length})</a>
                            {commentitem.id_comment_comment == 0 ? (<a className="mgl-10" onClick={this.handleReply.bind(this)}>Reply&nbsp;({commentitem.replies})</a>) : ""}
                        </div>
                        <div className="time_comment">{commentitem.time_comment}</div>
                    </div>
                </div>
                {this.state.show == true ? (<ReplyComment show={this.state.show} getInput={this.getInput.bind(this)}
                                                          onChange={this.props.onChange}
                                                          user={this.props.user}
                                                          handleComment={this.handleComment}
                                                          comment={commentitem}
                                                          feed={this.props.feed}/>) : ""}
                <POPUP style={customStyles2} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={this.state.msg} onClose={this.onCloseLoginPopover.bind(this)} />)} />
            </div>
        );
    }
}

export default CommentItem;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/CommentItem.js
 **/